// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"af0619ea","623":"cdc7178f","625":"1c11fc20","705":"99f8ca2b","847":"f419fad0","848":"51862377","900":"35a208fd","913":"debe9a4b","955":"5f454a7e"}[chunkId] + ".chunk.js";
};